window.toggleCmntReplyForm = function(commentId) {
    const replyForm = document.getElementById(`comment_${commentId}-reply-form`)
    if (!replyForm) return

    replyForm.classList.toggle('hidden')
}